<template>
  <HeaderTrade />

     <!-- Container Start { -->
     <div id="container" class="sts-trade-container">
       <!-- Contents Start { -->
       <div id="contents">

         <TradeTopNav 
          :pid="route.params.id"
         />
         
         <!-- content start -->
         <div class="contents-area">

           <!-- 체결 / 손익 start -->
           <div class="trade-result-area" id="tradeResultArea">

             <div class="trade-result-tab fm-top-tab">
               <div class="fm-tab-list">
                 <!-- tab button -->
                 <ul class="nav nav-tabs" id="tradeResultTabButton" role="tablist" @click="onResultTabList">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="trade-result-hold-Tab" data-bs-toggle="tab" data-bs-target="#tradeResultHoldTab" type="button" role="tab" aria-controls="tradeOrderSellTab" aria-selected="true" >
                        {{currentTradeType=='C'?'보유코인':'보유종목'}}
                        <span>({{currentAssetList.length}})</span>
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="trade-result-outstanding-tab" data-bs-toggle="tab" data-bs-target="#tradeResultOutstandingTab" type="button" role="tab" aria-controls="tradeOrderBuyTab" aria-selected="false" >
                        미체결
                        <span>({{currentOrderList.length}})</span>
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button   @click="onDailyTradeList"  class="nav-link" id="trade-result-today-tab" data-bs-toggle="tab" data-bs-target="#tradeResultTodayTab" type="button" role="tab" aria-controls="tradeOrderBuyTab" aria-selected="false">
                        당일매매내역
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button @click="onDailyProfitList" class="nav-link" id="trade-result-day-tab" data-bs-toggle="tab" data-bs-target="#tradeResultDayTab" type="button" role="tab" aria-controls="tradeOrderBuyTab" aria-selected="false">
                        일별매매손익
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button @click="onOrderHistory" class="nav-link" id="trade-result-history-tab" data-bs-toggle="tab" data-bs-target="#tradeResultHistoryTab" type="button" role="tab" aria-controls="tradeResultHistoryTab" aria-selected="false">
                        주문내역
                        </button>
                    </li>
                 </ul>
               </div>

               <!-- tab contents -->
               <div class="tab-content" id="tradeResultTabContents">
 
                 <!-- 보유 코인/종목/선물 start -->
                 <div class="tab-pane fade show active" id="tradeResultHoldTab" role="tabpanel" aria-labelledby="trade-result-hold-tab">
                    <div class="trade-bottom-null" v-if="currentAssetList && currentAssetList.length == 0">보유자산이 없습니다.</div>

                    <div class="trade-result-list">                            
                      <div
                        class="result-list-inner"
                        v-for="AssetItem  in currentAssetList"
                        :key = AssetItem.ID                               
                      >
                        <div class="inner-head">
                          <div class="left" @click="onClickedItemName(AssetItem)">
                            <p class="txt">{{AssetItem.NAME}}</p>
                          </div>
                          <div class="right">
                            <div>
                              <span class="txt">평가손익 :</span>
                              <span class="num" :class="AssetItem.COLOR_CLASS">{{AssetItem.PROFIT?AssetItem.PROFIT:0}}</span>
                            </div>
                            <div v-if="currentTradeType!='F'">
                              <span class="txt">수익률 :</span>
                              <span class="num" :class="currentTradeType=='F'?'':AssetItem.COLOR_CLASS">
                                <i></i>{{currentTradeType=='F'?'-':AssetItem.profitPre?Math.abs(AssetItem.profitPre).toFixed(2) + '%':0}}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="inner-body">
                          <ul class="body-list">
                            <li>
                              <div class="list-txt">
                                <span class="txt">매입가</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Number(AssetItem.PRICE))}}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">보유수량</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.COUNT, 4))}}</span>
                              </div>
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">구분</span>
                                <span class="num">{{getTradeType(AssetItem.TRADETYPE)}}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">현재가</span>
                                <span class="num" :class="Constant.UTIL.getUpdownColor(AssetItem.drate)">{{AssetItem.currentPrice?Constant.UTIL.numberWithCommas(AssetItem.currentPrice):0}}</span>
                              </div>
                            </li>
                            <li>
                              <div class="list-txt" v-if="currentTradeType!='F'">
                                <span class="txt">매입금액</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.COUNT * AssetItem.PRICE, 2))}}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">매도</span>
                                <span class="num"><button type="button" class="btn btn-dark btn-sell"  @click="onClickSell_m(AssetItem)">시장가 정리</button></span>
                              </div>
                              <div class="list-txt" v-if="currentTradeType == 'F'">
                                <span class="txt">공유하기</span>
                                <div class="bth-share"><button type="button" class="btn" @click="cpModal(AssetItem)"><img src="@/assets/images/trade/ico_share.png" alt="공유하기"></button></div>
                              </div>                              
                            </li>
                            <li v-if="currentTradeType!='F'">
                              <div class="list-txt">
                                <span class="txt">공유하기</span>
                                <div class="bth-share"><button type="button" class="btn" @click="cpModal(AssetItem)"><img src="@/assets/images/trade/ico_share.png" alt="공유하기"></button></div>
                              </div>
                              <div class="list-txt">
                              </div>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>

                  <!-- 보유 코인/종목/선물 하단 시작  -->
                  <!-- <div class="trade-result-summary">
                      <button type="button" class="btn btn-sm btn-outline-primary"  @click="onAssetSellSelected">일괄매도</button>
                  </div> -->
                  <!-- //보유 코인/종목/선물 하단 종료 -->

                 </div>
                 <!-- //보유 코인/종목/선물  end -->
 
                 <!-- 미체결 start -->
                 <div class="tab-pane fade" id="tradeResultOutstandingTab" role="tabpanel" aria-labelledby="trade-result-outstanding-tab">
                    <div class="trade-bottom-null" v-if="currentOrderList && currentOrderList.length==0">미체결 거래가 없습니다.</div>

                    <div class="trade-result-list">
                      <div
                        class="result-list-inner"
                        v-for="orderItem  in currentOrderList"
                        :key = orderItem.ID                         
                      >
                        <div class="inner-head">
                          <div class="left" @click="onClickedItemName(orderItem)">
                            <p class="txt">{{orderItem.NAME}}</p>
                          </div>
                          <div class="right">
                            <div>
                              <span class="txt">주문 :</span>
                              <span class="num">{{getTradeType(orderItem.TRADETYPE)}}</span>
                            </div>
                            <div>
                              <span class="txt">주문수량 :</span>
                              <span class="num">
                                {{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(orderItem.ORDERCOUNT, 4))}}
                              </span>
                            </div>
                          </div>
                        </div>                      

                        <div class="inner-body">
                          <ul class="body-list">
                            <li>
                              <div class="list-txt">
                                <span class="txt">미체결수량</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(orderItem.REMAINCOUNT, 4))}}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">주문가</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(currentTradeType=='F'?Number(orderItem.ORDERINDEX).toFixed(orderItem.NDOTPOS):Constant.UTIL.toFixedNum(orderItem.ORDERINDEX, 4))}}</span>
                              </div>
                            </li>
                            <li>
                              <div class="list-txt" v-if="currentTradeType!='F'">
                                <span class="txt">매입금액</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(orderItem.ORDERINDEX * orderItem.ORDERCOUNT, 2)) }}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">주문취소</span>
                                <span class="num"><button type="button" class="btn btn-sm btn-danger"  @click="onOrderCancleModal(orderItem)">주문취소</button></span>
                              </div>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>

                  <!-- 당일매매내역 하단 시작  -->
                  <!-- <div class="trade-result-summary">
                      <button type="button" class="btn btn-sm btn-outline-primary"  @click="onOrderCencelSelected">일괄취소</button>
                  </div> -->
                  <!-- //당일매매내역 하단 종료 -->     
                 </div>
                 <!-- //미체결 end -->
 
                 <!-- 당일매매내역 start -->
                 <div class="tab-pane fade" id="tradeResultTodayTab" role="tabpanel" aria-labelledby="trade-result-today-tab">
                   <div class="trade-bottom-null" v-if="dailyTradeData && dailyTradeData.length == 0">거래내역이 없습니다.</div>

                    <div class="trade-result-list">
                      <div
                        class="result-list-inner"
                        v-for="(item, index ) in dailyTradeData"
                        :key = index                       
                      >
                        <div class="inner-head">
                          <div class="left">
                            <p class="txt">{{item.NAME}}</p>
                          </div>
                          <div class="right">
                            <div>
                              <span class="txt">매매손익 :</span>
                              <span class="num" :class="Constant.UTIL.getUpdownColor(item.TPOL)">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(item.TPOL,2))}}</span>
                            </div>
                            <div>
                              <span class="txt">수익률 :</span>
                              <span class="num" :class="Constant.UTIL.getUpdownColor(item.TPOL)">
                                <i></i>{{Math.abs((item.TPOL /  item.TOTALPRICE) *100).toFixed(2) + "%"}}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="inner-body">
                          <ul class="body-list">
                            <li>
                              <div class="list-txt">
                                <span class="txt">주문시각</span>
                                <span class="num">{{item.CREATIONDATE.split(' ')[1]}}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">주문</span>
                                <span class="num">{{getTradeType(item.TRADETYPE)}}</span>
                              </div>
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">수량</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(item.ORDERCOUNT, 4))}}</span>
                              </div>
                              <!-- <div class="list-txt">
                                <span class="txt">주문취소</span>
                                <span class="num"><button type="button" class="btn btn-sm btn-danger"  @click="onOrderCancleModal(orderItem)">주문취소</button></span>
                              </div> -->
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                 <!-- //당일매매내역 end -->
 
                 <!-- 일별매매손익 start -->
                 <div class="tab-pane fade" id="tradeResultDayTab" role="tabpanel" aria-labelledby="trade-result-day-tab">
                   <div class="trade-bottom-null" v-if="dailyProfitData  && dailyProfitData.length == 0" >거래 내역이 없습니다.</div>

                    <div class="trade-result-list">
                      <div
                        class="result-list-inner"
                        v-for="(item, index ) in dailyProfitData"
                        :key = index
                        v-show="Number(item.SELL_TRADEPRICE)!=0"
                      >
                        <div class="inner-head">
                          <div class="left">
                            <p class="txt">{{getChangeDateStr(item.YYYYMMDD)}}</p>
                          </div>
                          <div class="right">
                            <!-- <div>
                              <span class="txt">매매손익 :</span>
                              <span class="num" :class="Constant.UTIL.getUpdownColor(currentTradeType=='F'? Number(item.KF_TPOL) + Number(item.FF_TPOL) :Number(item.SELL_TPOL) + Number(item.BUY_TPOL))">
                                {{Constant.UTIL.numberWithCommas(currentTradeType=='F'?  Number(item.KF_TPOL) + Number(item.FF_TPOL)  :Number(item.SELL_TPOL) + Number(item.BUY_TPOL))}}
                              </span>
                            </div> -->
                            <div v-if="currentTradeType!='F'">
                              <span class="txt">수익률 :</span>
                              <span class="num" :class="Constant.UTIL.getUpdownColor(Number(item.SELL_TPOL))">
                                <i></i>{{Math.abs(((Number(item.SELL_TPOL))/Number(item.SELL_TRADEPRICE))*100).toFixed(2) + "%"}}
                              </span>
                            </div>
                          </div>                          
                        </div>

                        <div class="inner-body">
                          <ul class="body-list">
                            <li>
                              <div class="list-txt">
                                <span class="txt">매매손익</span>
                                <span class="num" :class="Constant.UTIL.getUpdownColor(currentTradeType=='F'? Number(item.KF_TPOL) + Number(item.FF_TPOL) :Number(item.SELL_TPOL))">
                                  {{Constant.UTIL.numberWithCommas(currentTradeType=='F'?  Number(item.KF_TPOL) + Number(item.FF_TPOL)  :Number(item.SELL_TPOL))}}
                                </span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">누적손익</span>
                                <span class="num" :class="Constant.UTIL.getUpdownColor(item._sumProfit)">
                                  {{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(item._sumProfit,2))}}
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>

                 </div>
                 <!-- //일별매매손익 end -->
                 
                  <!-- 주문내역 start -->
                 <div class="tab-pane fade" id="tradeResultHistoryTab" role="tabpanel" aria-labelledby="trade-result-history-tab">
                   <div class="trade-bottom-null" v-if="orderHistoryData  && orderHistoryData.length == 0 ">거래내역이 없습니다.</div>

                    <div class="trade-result-list">
                      <div
                        class="result-list-inner"
                        v-for="(item, index ) in orderHistoryData"
                        :key = index                    
                      >
                        <div class="inner-head">
                          <div class="left">
                            <p class="txt t2">
                              {{item.NAME}}
                            </p>
                            <span class="unit">{{getChangeDateStr_2(item.ORDERDATE)}}</span>
                          </div>
                          <div class="right">
                            <div>
                              <span class="txt">구분 :</span>
                              <span class="num" :class="item.TRADETYPE=='1'||item.TRADETYPE=='3'?'up':'down'">
                                {{getTradeType(item.TRADETYPE)}}
                              </span>
                            </div>
                            <div>
                              <span class="txt">실현손익 :</span>
                              <span class="num" :class="item.STATUS == '2'?getCssColor(Number(item.TPOL)):''">
                                <i></i>{{item.STATUS == '2'?Constant.UTIL.numberWithCommas(Math.abs(Math.floor(item.TPOL))):'-'}}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="inner-body">
                          <ul class="body-list">
                            <li>
                              <div class="list-txt">
                                <span class="txt">수량</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(item.ORDERCOUNT, 2))}}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">가격</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(item.STATUS=='1'?item.ORDERINDEX:item.TRADEINDEX, 4))}}</span>
                              </div>
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">수수료</span>
                                <span class="num">{{item.FEES?Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(item.FEES, 2)):'-'}}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">상태</span>
                                <span class="num">{{getTradeStatus(item.STATUS)}}</span>
                              </div>
                            </li>
                            <li  v-if="item.ASSETINDEX!=null">
                              <div class="list-txt" >
                                <span class="txt">공유하기</span>
                                <div class="bth-share"><button type="button" class="btn" @click="cpModalSell(item)"><img src="@/assets/images/trade/ico_share.png" alt="공유하기"></button></div>
                              </div>
                              <div class="list-txt">
                              </div>
                            </li>                            
                          </ul>
                        </div>

                      </div>
                    </div>
                 </div>
               </div>

           </div>
           <!-- //체결 / 손익 end -->

          </div>
         </div>
         <!-- // content end -->

         <TradeBottomNav 
          :id="route.params.id"
         />

       </div>
       <!-- } Contents End -->
     </div>
     <!-- } Container End -->

    <BasicModal2b
      v-if="showModal3"
      @close="closeModal3" 
      @cancle="closeModal3" 
      @ok="onModalOk3" 
      :titleTxt="txtTitle_alert3"
      :bodyTxt="txtBody_alert3"
    />

    <BasicModal2b
      v-if="showModal2"
      @close="closeModal2" 
      @cancle="closeModal2" 
      @ok="onModalOk2" 
      :titleTxt="txtTitle_alert2"
      :bodyTxt="txtBody_alert2"
    />

    <BasicModal2b
      v-if="showModal"
      @close="closeModal" 
      @cancle="closeModal" 
      @ok="onModalOk" 
      :titleTxt="txtTitle_alert"
      :bodyTxt="txtBody_alert"
    />

    <CaptureModal
      v-if="showModal4" 
      @close="closeModal4" 
      @cancle="closeModal4" 
      @ok="okModal4" 
      :assetData="currentAssetItem"
    />

    <CaptureModalSell
      v-if="showModal5" 
      @close="closeModal5" 
      @cancle="closeModal5" 
      @ok="okModal5" 
      :assetData="currentOrderHistoryItem"
    />    

</template>

<script>
import { useStore } from 'vuex';
import HeaderTrade from '@/components/HeaderTrade.vue';
import TradeTopNav from "@/components/TradeTopNav.vue"
import TradeBottomNav from "@/components/TradeBottomNav.vue"

// import { PerfectScrollbar } from 'vue3-perfect-scrollbar';

import axios from '@/axios';
//import { useToast } from '@/composables/toast';
import BasicModal2b from '@/components/popups/BasicModal2b.vue';
import { computed, onMounted, onUnmounted, watchEffect, getCurrentInstance, ref, watch} from 'vue';
import Constant from '@/constant.js';
import {useApicall} from '@/composables/commonFn';
import {useRouter , useRoute}from 'vue-router'
import moment from 'moment';
import { useScoket } from '@/socket';
import {useBalance, useGetItemList} from '@/composables/vtradeFn';
import CaptureModal from '@/components/popups/CaptureModal.vue';
import CaptureModalSell from '@/components/popups/CaptureModalSell.vue';
import { event } from 'vue-gtag'
export default {
   components:{   
       HeaderTrade,
       TradeTopNav,
       TradeBottomNav,
      //  PerfectScrollbar,
       BasicModal2b,
       CaptureModal,
       CaptureModalSell
   },
   
   setup(){
     // const $ = require('jquery');
     const {socket} = useScoket();
     const selectItem = ref(null)

     const router = useRouter();
     const  {getItemListBySessionStorage} = useGetItemList()
     const store = useStore();
     store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_0'); 
     store.commit('trade/CHANGE_CURRENT_PAGE_BOTTOM', 'tradeResult'); 
     const memberData = computed(()=> store.state.user.memberData);
     const onResultTabList = (e) => {
       var btn = e.target;
       btn.scrollIntoView({behavior: "smooth" ,inline: "center"});
      // console.log("scrollbar",  $('.trade-result-tbl'))
      // $('.trade-result-tbl').scrollLeft = 0
       
     }
     var items = null;
      
      // const scrollbar = ref(null);
      const route = useRoute();
      // const {         
      //               triggerToast
      //       } = useToast();
      const  trace = getCurrentInstance().appContext.config.globalProperties.$log;

      const currentTradeType = computed(()=> store.state.hts.currentTradeType);
      const currentOrderList = computed(()=> store.state.hts.orderList);
      const currentAssetList = computed(()=> store.state.hts.assetlist);
      
      const {apiCall_gt} = useApicall()
      const  currentAssetItem = ref({});
      const  currentOrderHistoryItem = ref({});     

      
      const isLogin = computed(() => store.state.user.isLogin);

      const txtTitle_alert = ref("일괄 매도");
      const txtBody_alert = ref("선택된 주문을 매도하시겠습니까?")


      const txtTitle_alert2 = ref("일괄 취소");
      const txtBody_alert2 = ref("선택된 주문을 취소하시겠습니까?")

      
      const txtTitle_alert3 = ref("시장가 정리");
      const txtBody_alert3 = ref("시장가로 매도를 원하시면 아래 확인 버튼을 눌러주세요.")

      const  {getItemByCode} = useGetItemList()
      //const itemType = computed(()=> store.state.hts.currentTradeType);
      const currencyInfo = computed(()=> store.state.hts.currencyInfo);
      const allTrade = computed(()=> store.state.hts.allTrade);
      const showModal = ref(false);        
      const showModal2 = ref(false); 
      const showModal3 = ref(false);
      const showModal4 = ref(false);
      const showModal5 = ref(false);
      var intervalId;
      var orderCancelItem = null;
      var assetSellItem = null;
      const dailyTradeData = ref([]);
      const dailyProfitData = ref([]);
      const {setCurrentBalance} = useBalance(); 
      const applySpaceList = computed(()=> store.state.hts.applySpaceList);    
    // const item = ref(null)
     

      console.log("applySpaceList :", applySpaceList.value)

      const getIsApplySpace = (spaceId) =>{
          if (!applySpaceList.value)return false;
          var  found =    applySpaceList.value.find(element => element.SPACE_ID == spaceId);          
          if(found)
          {
            return true;
          }
          else
          {
            return false;
          }
      }

      if(route.params.id == '0')
      {
        store.commit('trade/CHANGE_CURRENT_LEAGUETYPE', 'normal');
      }
      else
      {
        store.commit('trade/CHANGE_CURRENT_LEAGUETYPE', 'event');
      }
   
      const orderHistoryData = ref({})
      const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;

           
      const onClickedItemName = (item) =>{

          var t_item = items.find(element => element.CODE ==  item.CODE); 
          
          
          if(currentTradeType.value== 'F' && t_item.SUBTYPE == 'K')     
          { 
              var date = new Date()
              if(date.getHours() >= 18)
              {
                  t_item =  items.find(element => element.CODE ==  item.CODE && element.isNight); 
              }
          } 
          if(!isLogin.value)
          {
            emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 사용가능합니다."});
            return;
          }            
          sessionStorage.setItem(`startItem_${currentTradeType.value}`, JSON.stringify(t_item)); 
          

          router.push({
            name: 'TradeArea',
            params: {
              code:t_item.CODE,   
              id:route.params.id            
            }
          }) 

        // console.log("onClickedItemName", t_item, item)
      }

      onUnmounted(()=>{             
          store.dispatch('hts/leaveAssetItems');
          clearInterval(intervalId);
      })


      onMounted( async ()=>{
          items = await getItemListBySessionStorage(currentTradeType.value);
          store.commit('hts/CHANGE_ASSETLIST',[]);
          store.commit('hts/CHANGE_ORDERLIST', []);
          if(store.state.hts.currentSpaceId != null &&  store.state.hts.currentSpaceId != -1 )
          {
                  setCurrentBalance(store.state.hts.currentSpaceId);  
          }

          selectItem.value = await getItemByCode(currentTradeType.value, route.params.code) 
          
          if(selectItem.value.TYPE == 'F')
          {         
            if(selectItem.value.isNight  && String(selectItem.value.isNight) == 'true') 
            { 
                selectItem.value.CODE = selectItem.value.CODE.split('_')[0];  
            }        
          }

          store.commit('hts/CHANGE_CURRENT_ITEM', selectItem.value);

          setTimeout(()=>{
           
            var isApply = getIsApplySpace(store.state.hts.currentSpaceId);   
          //  console.log("aaaaa:", isApply, store.state.hts.currentSpaceId)           
            if(isApply)
            {
               
               getOrderList();
               getAssetList();
                //store.dispatch('hts/getOrderList');
                //store.dispatch('hts/getAssetList')
            }
            else
            {              
                store.commit('hts/CHANGE_ASSETLIST',[]);
                store.commit('hts/CHANGE_TOTAL_POL',{});
                if(currentTradeType.value == 'F')
                {
                    store.commit('hts/CHANGE_FUTURE_POSSIBLE_COUNT', {});
                }

                store.commit('hts/CHANGE_ORDERLIST', []);
            }
          }, 1000)

          clearInterval(intervalId);
          intervalId = setInterval(()=>{
              var totalProfit = 0;
              var totalPrice = 0;
              for(var i=0; i<currentAssetList.value.length ; i++)
              {
                  if(currentAssetList.value[i])
                  {
                      totalProfit += Number(currentAssetList.value[i].nProfit) *Number(currentAssetList.value[i].COUNT);
                      totalPrice += (Number(currentAssetList.value[i].PRICE) + Number(currentAssetList.value[i].nProfit))  *Number(currentAssetList.value[i].COUNT);                           
                  }  
              }
              store.commit('hts/CHANGE_TOTAL_PRICE',totalPrice); 
              store.commit('hts/CHANGE_TOTAL_PROFIT',totalProfit); 
          },1000) 
      })




      const getOrderList = async () => {   

        if(store.state.hts.currentSpaceId == null)return;
        var token = sessionStorage.getItem('token');  
        try{            
            const  res = await axios.get(`vspace/getorderlist?spaceId=${store.state.hts.currentSpaceId}`, {
                headers: {
                    'token': token
                }
            });   
            
            let json =  res.data;   
            if (json.returnCode == 1) {
                if (json.resultMap.returnVal == 1) {  
                  
                    if(!json.resultMap.dataList) json.resultMap.dataList = [];
                    store.commit('hts/CHANGE_ORDERLIST', json.resultMap.dataList);
                    
                    if(json.resultMap.dataList.length > 0)
                    {
                        json.resultMap.dataList.forEach(element =>
                        {
                            element.checked =  false;                           
                        } );
                    }                   
                } else {                    
                    store.commit('hts/CHANGE_ORDERLIST', []);
                    console.log(json.message);
                }
            }
            else if(json.returnCode == -102 )
            {
                console.log("로그인이 필요합니다.");
            }
            else
            {            
                  console.log(json.message);
            }               
        }catch(error){            
            console.log(error);
        }  
      }



      const getAssetList = async () => { 
            if(store.state.hts.currentSpaceId == null)return;
            var token = sessionStorage.getItem('token');
            try{
                const  res = await axios.get(`vspace/getassetlist?spaceId=${store.state.hts.currentSpaceId }`, {
                    headers: {
                        'token': token
                   }
                });   
                let json =  res.data;   
                if (json.returnCode == 1) {
                    if (json.resultMap.returnVal == 1) { 
                        if(!json.resultMap.dataList) json.resultMap.dataList = [];
                         store.commit('hts/CHANGE_ASSETLIST', json.resultMap.dataList);
                         store.commit('hts/CHANGE_TOTAL_POL', json.resultMap.dataSum);
                      
                        if(json.resultMap.dataList.length > 0)
                        {
                            json.resultMap.dataList.forEach(element =>
                            {
                                element.checked =  false;                           
                            } );
                        }                                  
                        if(store.state.hts.currentTradeType == 'F')
                        {
                            store.dispatch('hts/setPossibleOrder')
                            var losscut = 0
                            if(json.resultMap.dataList)
                            {
                                json.resultMap.dataList.forEach(element =>{
                                   // console.log(element);
                                     losscut += Number(element.LOSSCUT)*parseInt(element.COUNT);
                                })
                            }
                            store.commit('hts/CHANGE_CURRENT_LOSSCUT', losscut);
                            store.commit('hts/CHANGE_TOTAL_POL', json.resultMap.dataSum);                            
                        }  
                       
                       requesAssetItems()
                    } else {
                         store.commit('hts/CHANGE_ASSETLIST', []);       
                    }
                }
                else if(json.returnCode == -102 )
                {
                    console.log("로그인이 필요합니다.");
                }
                else
                {               
                  console.log(json.message);
                }               
            }catch(error){             
                console.log(error);
            }  
        } 

        const requesAssetItems =  () => { 
            
            //var isNight = false;
            //if(store.state.hts.currentItem && store.state.hts.currentItem.isNight) isNight = true;   
            var assetInitArr = []
            setTimeout(()=>{
                for(let i=0; i<store.state.hts.assetlist.length; i++)
                {
                    var item = store.state.hts.assetlist[i];                   
                    var assetInitData = 
                    { "drate" :  "0" , 
                      "trade_price" : Number(item.CURRENT),
                      "code": item.CODE,
                      "price": Number(item.CURRENT)
                    }

                    if(item.KIND == "S" || item.KIND == "C" || item.KIND == "G" )
                    {
                      assetInitData.itemType = item.KIND;
                    }
                    else
                    {
                      assetInitData.itemType = 'F';                           
                    }
                    
                    assetInitArr.push(assetInitData);     
                    socket.emit("requestTrade", {
                        itemType:store.state.hts.currentTradeType,
                        code: item.CODE,
                       // isNight:isNight  
                    }, function() {       
                        // console.log("connect socket requestTrade~111",state.currentTradeType, item.CODE ) 
                    })
                }

                for(let ii=0; ii<assetInitArr.length; ii++)
                {
                    //  console.log("aaaaaa~", assetInitArr.shift() ) 
                    setTimeout(()=>{
                        store.commit('hts/CHANGE_ALL_TEADE', assetInitArr.shift()) 
                    }, ii * 200)                    
                }
            },1500)
        }


        const getTradeType = (type) =>{
            switch(type)
            {
                case '1':
                    return "매수"                        
                case '2':
                    return "매도"                       
                case '3':
                    return "매수"                        
                case '4':
                    return "매도"
            }
        }

  
        watchEffect(()=>{
          if(currentTradeType.value == 'F' &&  items)
          {
              for(let i=0; i<currentOrderList.value.length ;i++)
              {
                  let orderData = currentOrderList.value[i];
                  let t_item =  items.find(element => element.CODE ==  orderData.CODE);
                  if(t_item && t_item.NDOTPOS) orderData._NDOTPOS = t_item.NDOTPOS;                  
              }
              for(let i=0; i<currentAssetList.value.length ;i++)
              {
                  let assetData = currentAssetList.value[i];
                  let t_item = items.find(element => element.CODE ==  assetData.CODE);
                  if(t_item && t_item.NDOTPOS) assetData._NDOTPOS = t_item.NDOTPOS;                  
              }
          }
        })

      watch(allTrade,()=>{          
        var  tradeItem = allTrade.value;   
        const found =  currentAssetList.value.find(element => element.CODE ==  tradeItem.code);           
        if(!found)return;        
        var profit; 
         
        if(tradeItem.itemType == 'F')
        {
              if(items)
              {
                  var t_item =  items.find(element => element.CODE ==  found.CODE); 
              }
              
              if(t_item)
              {
                  if(t_item.MINCHANGEAMOUNT)
                  {
                      if(t_item.PRODUCTCODE == 'HSI')
                      {
                          profit = (Number(tradeItem.trade_price) - Number(found.PRICE)) / Number(t_item.HOGAUNITPRICE) * Number(t_item.MINCHANGEAMOUNT) * Number(currencyInfo.value.HKD_KRW) * Number(found.COUNT);
                          found.nProfit = (Number(tradeItem.trade_price) - Number(found.PRICE)) / Number(t_item.HOGAUNITPRICE) * Number(t_item.MINCHANGEAMOUNT) * Number(currencyInfo.value.HKD_KRW);                        
                      }
                      else
                      {
                          profit = (Number(tradeItem.trade_price) - Number(found.PRICE)) / Number(t_item.HOGAUNITPRICE) * Number(t_item.MINCHANGEAMOUNT) * Number(currencyInfo.value.USD_KRW) * Number(found.COUNT);
                          found.nProfit = (Number(tradeItem.trade_price) - Number(found.PRICE)) / Number(t_item.HOGAUNITPRICE) * Number(t_item.MINCHANGEAMOUNT) * Number(currencyInfo.value.USD_KRW);                           
                      }
                  }
                  else
                  {
                      if(t_item.SUBTYPE == 'K')
                      { 
                          profit = ((Number(tradeItem.trade_price) - Number(found.PRICE)) *Number(found.COUNT))*250000; 
                          found.nProfit = ((Number(tradeItem.trade_price) - Number(found.PRICE)))*250000;  
                      }
                  } 
                  found.currentPrice = tradeItem.trade_price;
                  found.drate = Number(tradeItem.drate);
              } 
              if(found.TRADETYPE == '4')
              {
                  found.nProfit *= -1;
                  profit *= -1;
              }                 
              profit = Math.floor(profit)   
          }
          else
          {
            profit = (Number(tradeItem.trade_price) - Number(found.PRICE)) *Number(found.COUNT);  
            found.nProfit = (Number(tradeItem.trade_price) - Number(found.PRICE)); 
            let profitPre = (found.nProfit /  Number(found.PRICE)) *100;
            found.profitPre = profitPre;
            found.currentPrice = tradeItem.trade_price;
            if(tradeItem.itemType == 'C')
            {
                found.drate = Number(tradeItem.trade_price) -  Number(tradeItem.prev_closing_price);
            }
            else
            {
              found.drate = Number(tradeItem.drate);
            }          
            profit = Math.floor(profit);  
          }

          if(profit > 0)
          {
              found.COLOR_CLASS = "up"
              found.PROFIT = '+' + Constant.UTIL.numberWithCommas(profit);
              found._profit = profit
              
          }
          else if(profit < 0)
          {
            found.COLOR_CLASS = "down";
            found.PROFIT =  Constant.UTIL.numberWithCommas(profit);
            found._profit = profit;
          }
          else
          {
            found.COLOR_CLASS = "";
            found.PROFIT = '0';
            found._profit = profit
          } 

      })



   
    const onDailyProfitList = async()=>{         
        var res = await apiCall_gt(`vspace/getprofitlistbyday?type=${currentTradeType.value}&spaceId=${store.state.hts.currentSpaceId}`);
         if(res.dataList == null) res.dataList = []
        dailyProfitData.value = res.dataList;        
        var prevSumPol = null;
        for(let i= dailyProfitData.value.length -1 ; i>=0; i-- )
        {
          var _data = dailyProfitData.value[i];
          if(prevSumPol)
          {
            if(currentTradeType.value == 'F' )
            {
                _data._sumProfit = prevSumPol +  Number(_data.KF_TPOL) + Number(_data.FF_TPOL);
            }
            else
            {
                 _data._sumProfit = prevSumPol + Number(_data.SELL_TPOL);
            }            
          }
          else
          {
            if(currentTradeType.value == 'F' )
            {
                 _data._sumProfit = Number(_data.KF_TPOL) + Number(_data.FF_TPOL);
            }
            else
            {
               _data._sumProfit = Number(_data.SELL_TPOL);
            }             
          }         
          prevSumPol = _data._sumProfit;
        }
      }

      const onDailyTradeList = async()=>{
        var dateStr = moment(new Date()).format('YYYY-MM-DD');        
        var res = await apiCall_gt(`vspace/gettradelist?type=${currentTradeType.value}&spaceId=${store.state.hts.currentSpaceId}&startCreationDay=${dateStr}&endCreationDay=${dateStr}&status=2`);
        if(res.dataList == null) res.dataList = []
        dailyTradeData.value = res.dataList;
      }


     const getTradeList = async()=>{
                
        var res = await apiCall_gt(`vspace/gettradelist?type=${currentTradeType.value}&spaceId=${store.state.hts.currentSpaceId}&status=2`);
        if(res.dataList == null) res.dataList = []
        orderHistoryData.value = res.dataList;
      }


      const onCheckAssetSelectAll =(e)=>{
         
           if(e.target.checked == true)
           {           
                currentAssetList.value.forEach(element =>
                {
                   trace("element", element)
                    element.checked =  true;                    
                });
           }
           else
           {
                currentAssetList.value.forEach(element =>
                {
                    element.checked =  false;                    
                });
           }           
      }
      
     const onCheckOrderSelectAll =(e)=>{
        
           if(e.target.checked == true)
           {           
                currentOrderList.value.forEach(element =>
                {                  
                    element.checked =  true;                    
                });
           }
           else
           {
                currentOrderList.value.forEach(element =>
                {
                    element.checked =  false;                    
                });
           }           
      }

     const onAssetSellSelected = ()=>{      
        var isChecked = false       
        if(currentAssetList.value  ||  currentAssetList.value.length > 0)
        {
          currentAssetList.value.forEach(async element =>
          {       
              if(element.checked)
              {
                isChecked = true;
              }
          })
        }

        if(isChecked)
        {
            showModal.value = true;
        }
        else
        {
             emitter.emit('EVENT_ALERT',{title:"알림", body:"선택된 주문이 없습니다."});
        }
     }

     const onOrderCencelSelected = ()=>{
        

          

        var isChecked = false       
        if(currentOrderList.value  ||  currentOrderList.value.length > 0)
        {
          currentOrderList.value.forEach(async element =>
          {       
              if(element.checked)
              {
                isChecked = true;
              }
          })
        }

        if(isChecked)
        {
             showModal2.value = true;
        }
        else
        {
             emitter.emit('EVENT_ALERT',{title:"알림", body:"선택된 주문이 없습니다."});
        }





     }

    const getTradingTypeStr = (type)=>{
      var result = null;
      if(type == 'S')
      {
        result = 'stock_tranding'
      }
      else if(type == 'F')
      {
        result = 'futures_tranding'
      }
      else if(type == 'C')
      {
        result = 'crypto_tranding'
      }
      else if(type == 'G')
      {
        result = 'coinFutures_tranding'
      }
      return result;
    }


     const closeModal =()=>{
        showModal.value = false;
     }

    const closeModal2 =()=>{
        showModal2.value = false;
        orderCancelItem = null;
     }

  
    const onModalOk = ()=>{
        showModal.value = false;
        var token = sessionStorage.getItem('token');   

        

        currentAssetList.value.forEach(async element =>
        {       
            if(element.checked)
            {

                  var t_tradeType; 
                  if(element.TRADETYPE == "1") t_tradeType = "2";
                  else if(element.TRADETYPE == "2") t_tradeType = "1";  
                  else if(element.TRADETYPE == "3") t_tradeType = "4";  
                  else if(element.TRADETYPE == "4") t_tradeType = "3"; 
                  trace("element:", element) 
                   
                  var params = {
                        spaceId: store.state.hts.currentSpaceId,
                        type:  currentTradeType.value,
                        orderType:'M',
                        tradeType : t_tradeType,
                        code:element.CODE,                        
                        count:element.COUNT,   
                        isCleared:"Y"                            
                } 
                    
                try{
                    const res = await axios.post('vspace/orderregister', params ,{
                        headers: {
                                'token': token,                    
                        }
                    });   
                    let json =  res.data;                     
                    if (json.returnCode == 1) {
                    
                        if (json.resultMap.returnVal == 1) {  
                           // triggerToast('주문이 완료되었습니다.');                           
                          store.dispatch('hts/getAssetList');
                           
                          var gtag_type = null;
                          if(json.resultMap.orderRow.TRADETYPE == "1" || json.resultMap.orderRow.TRADETYPE == "3")
                          {
                            gtag_type = 'buy' 
                          }
                          else if(json.resultMap.orderRow.TRADETYPE == "2" || json.resultMap.orderRow.TRADETYPE == "4")
                          { 
                            gtag_type = 'sell' 
                          }
                          event( getTradingTypeStr(params.type), { 'ID': memberData.value.MID, 'transaction_type': gtag_type, 'time': moment(new Date()).format('YYYYMMDD HH:mm:ss')});
                          window.fbq('trackCustom', getTradingTypeStr(params.type), {'ID':  memberData.value.MID,  'transaction_type': gtag_type,'time': moment(new Date()).format('YYYYMMDD HH:mm:ss') });
                          console.log("event~ :",getTradingTypeStr(params.type), memberData.value.MID , gtag_type,  moment(new Date()).format('YYYYMMDD HH:mm:ss')) 
                          

                        } else {
                           // triggerToast(json.message, 'danger');       
                            emitter.emit('EVENT_ALERT',{title:"알림", body:json.message});                            
                            showModal.value = false 
                            showModal2.value = false
                            showModal3.value = false
                        }
                    }
                    else if(json.returnCode == -102 )
                    {
                        alert("로그인이 필요합니다.");
                    }
                    else
                    {
                     // triggerToast(json.message, 'danger');                     
                    }              
                }catch(error){
                   // triggerToast('Something went wrong!', 'danger');
                    console.log(error);
                } 
            }
        });
     }


   const onOrderCancleModal = (item)=>{
       showModal2.value = true;
       orderCancelItem = item;
   }

    const onOrderCancle = async ()=>{
       showModal2.value = false;
       
      var token = sessionStorage.getItem('token'); 
      var params = {                            
                          type:  currentTradeType.value,
                          orderId:orderCancelItem.ID,       
                    } 
          try{
              orderCancelItem = null;
              const res = await axios.post('vspace/ordercancel', params ,{
                  headers: {
                          'token': token,                    
                  }
              });   
              let json =  res.data;                     
              if (json.returnCode == 1) {
              
                  if (json.resultMap.returnVal == 1) {  
                     // triggerToast('주문이 취소가 완료되었습니다.'); 
                      store.dispatch('hts/getOrderList');      
                  } else {
                      //triggerToast(json.message, 'danger');                        
                      emitter.emit('EVENT_ALERT',{title:"알림", body:json.message});   
                      showModal.value = false 
                      showModal2.value = false
                      showModal3.value = false        
                  }
              }
              else if(json.returnCode == -102 )
              {
                  alert("로그인이 필요합니다.");
              }
              else
              {
               // triggerToast(json.message, 'danger');                     
              }              
          }catch(error){
             // triggerToast('Something went wrong!', 'danger');
              console.log(error);
          } 
    }

    const onScroll = (e) =>{
          e
          // trace(e.target, e.target.scrollLeft); 
      }

    const onModalOk2 = ()=>{
          showModal2.value = false;

          if(orderCancelItem)
          {
              onOrderCancle()
          }
          else
          {
              var token = sessionStorage.getItem('token');   
              currentOrderList.value.forEach(async element =>
              {       
                  if(element.checked)
                  {

                      var params = {                            
                            type:  currentTradeType.value,
                            orderId:element.ID,       
                      } 
                      try{
                          const res = await axios.post('vspace/ordercancel', params ,{
                              headers: {
                                      'token': token,                    
                              }
                          });   
                          let json =  res.data;                     
                          if (json.returnCode == 1) {
                          
                              if (json.resultMap.returnVal == 1) {  
                                 // triggerToast('주문 취소가 완료되었습니다.'); 
                                store.dispatch('hts/getOrderList');      
                              } else {
                                 // triggerToast(json.message, 'danger');     
                                  emitter.emit('EVENT_ALERT',{title:"알림", body:json.message});                        
                                  showModal.value = false 
                                  showModal2.value = false
                                  showModal3.value = false        
                              }
                          }
                          else if(json.returnCode == -102 )
                          {
                              alert("로그인이 필요합니다.");
                          }
                          else
                          {
                           // triggerToast(json.message, 'danger');                     
                          }              
                      }catch(error){
                        //  triggerToast('Something went wrong!', 'danger');
                          console.log(error);
                      } 
                  }
              });
          }

    }
     const closeModal3 = () =>{
         showModal3.value = false;
         assetSellItem = null;
     }
     const onModalOk3 = async () =>{
            var t_tradeType; 
            if(assetSellItem.TRADETYPE == "1") t_tradeType = "2";
            else if(assetSellItem.TRADETYPE == "2") t_tradeType = "1";  
            else if(assetSellItem.TRADETYPE == "3") t_tradeType = "4";  
            else if(assetSellItem.TRADETYPE == "4") t_tradeType = "3"; 
            
            var token = sessionStorage.getItem('token');       
            var params = {
                  spaceId: store.state.hts.currentSpaceId,
                  type:  currentTradeType.value,
                  orderType:'M',
                  tradeType : t_tradeType,
                  code:assetSellItem.CODE,                        
                  count:assetSellItem.COUNT,   
                  isCleared:"Y"                            
            } 
                
            try{
                const res = await axios.post('vspace/orderregister', params ,{
                    headers: {
                            'token': token,                    
                    }
                });   
                let json =  res.data;                     
                if (json.returnCode == 1) {
                
                    if (json.resultMap.returnVal == 1) {  
                      //  triggerToast('주문이 완료되었습니다.');                           
                        store.dispatch('hts/getAssetList')                            
                        showModal3.value = false;
                        assetSellItem = null;


                        var gtag_type = null;
                        if(json.resultMap.orderRow.TRADETYPE == "1" || json.resultMap.orderRow.TRADETYPE == "3")
                        {
                          gtag_type = 'buy' 
                        }
                        else if(json.resultMap.orderRow.TRADETYPE == "2" || json.resultMap.orderRow.TRADETYPE == "4")
                        { 
                          gtag_type = 'sell' 
                        }
                        event( getTradingTypeStr(params.type), { 'ID': memberData.value.MID, 'transaction_type': gtag_type, 'time': moment(new Date()).format('YYYYMMDD HH:mm:ss')})
                        window.fbq('trackCustom', getTradingTypeStr(params.type), {'ID':  memberData.value.MID,  'transaction_type': gtag_type,'time': moment(new Date()).format('YYYYMMDD HH:mm:ss') });
                        console.log("event~ :",getTradingTypeStr(params.type), memberData.value.MID , gtag_type,  moment(new Date()).format('YYYYMMDD HH:mm:ss'))




                    } else {
                       // triggerToast(json.message, 'danger');    
                        emitter.emit('EVENT_ALERT',{title:"알림", body:json.message});                    
                        showModal.value = false 
                        showModal2.value = false
                        showModal3.value = false        
                    }
                }
                else if(json.returnCode == -102 )
                {
                    alert("로그인이 필요합니다.");
                }
                else
                {
                  //triggerToast(json.message, 'danger');                     
                }              
            }catch(error){
                //triggerToast('Something went wrong!', 'danger');
                console.log(error);
            } 
     }
     const onClickSell_m = (item) =>{
        showModal3.value = true;
        assetSellItem = item;
     }


    const getChangeDateStr=(str)=>{  
       return moment(str, "YYYYMMDD").format("YYYY-MM-DD");
     }

    const getChangeDateStr_2=(str)=>{  
       return moment(str, "YYYYMMDDhhmmss").format("YYYY-MM-DD HH:mm:ss");
     }

     const onOrderHistory = () =>{
           getTradeList()
     }

     const getTradeStatus = (type) =>{
        switch(type)
        {
            case '1':
                return "신규"                        
            case '2':
                return "체결"                       
            case '8':
                return "거부"                        
            case '9':
                return "취소"
        }
      }

    const getCssColor = (num) => {
          var result = ''
          if(num > 0)
          {
              result = "up" 
          }
          else if(num < 0)
          {
              result = "down"         
          }
          else
          {
              result = ""      
          } 
          return result;
      }

    const cpModal = (item) => {
      currentAssetItem.value = item
      showModal4.value = true; 
    }

    const okModal4 = () => {
      showModal4.value = false; 
    }

    const closeModal4 = () => {
      showModal4.value = false; 
    }    


    const cpModalSell = (item) => {
      currentOrderHistoryItem.value = item;
      showModal5.value = true; 
    }

    const okModal5 = () => {
      showModal5.value = false; 
    }

    const closeModal5 = () => {
      showModal5.value = false; 
    }   


     return{
       onResultTabList,
      //  scrollbar,
        //   options: {       
        //         wheelSpeed: 1,
        //         wheelPropagation: true,
        //         minScrollbarLength: 20,
        //         suppressScrollX: true,
        //   },
        //   watcher: true,
          currentOrderList,
          currentAssetList,
          Constant,
          getTradeType,
        
          //periodInitDataKeep,
          onCheckAssetSelectAll,
          onCheckOrderSelectAll,
          onAssetSellSelected,
          closeModal,
          onModalOk,
          showModal,
          txtTitle_alert,
          txtBody_alert,
          showModal2,
          txtTitle_alert2,
          txtBody_alert2,
          closeModal2,
          onModalOk2,
          showModal3,
          txtTitle_alert3,
          txtBody_alert3,
          closeModal3,
          onModalOk3,
          onOrderCencelSelected,
          onOrderCancleModal,
          currentTradeType,
          onDailyTradeList,
          dailyTradeData,
          onScroll,
          onDailyProfitList,
          dailyProfitData,
          getChangeDateStr,
          onClickedItemName,
          onClickSell_m,
          isLogin,
          onOrderHistory,
          orderHistoryData,
          getChangeDateStr_2,
          getTradeStatus,
          getCssColor,
          cpModal,
          showModal4,
          closeModal4,
          okModal4,
          currentAssetItem,
          currentOrderHistoryItem,
          cpModalSell,
          showModal5,
          closeModal5,
          okModal5,
          route
     }
   }
}
</script>

<style>

</style>